module.exports = __webpack_public_path__ + "australia.39d9f050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/australia.png
// module id = 122
// module chunks = 0